declare global {
  interface Window {
    analytics: any;
  }
}

export const trackEvent = (key: string, value: object) => {
  window.analytics.track(key, value);
};
